<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div class="multi-role-select-wrapper">
	<mat-extended-select
		[placeholder]="placeholder"
		[option$]="roleListSubject$"
		[includeFilter]="true"
		[multiSelect]="true"
		[formControl]="internalField"
		[valuePath]="[]"
		[required]="false"
		[iconBackgroundColorPath]="['database', 'color']"
		[subScriptSizing]="'dynamic'"
	>
	</mat-extended-select>
</div>
